package fr.manyverse.app.infrastructure.audio


/**
 * Web/JS implementation of AudioPlayer using Web Audio API for Safari-compatible volume control.
 */
actual fun createAudioPlayer(): AudioPlayer = JsAudioPlayer()
